import { ReactNode } from 'react'

import { IDate } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { formatDate, parseISODate } from '../../../../utils'
import { Tooltip } from '../../../Tooltip'
import * as S from '../../ReviewTimeline.styles'

type ReviewTimelineItem = {
  id: string
  createdAt: IDate
}

export interface ReviewTimelineLayoutProps<TDataItem extends ReviewTimelineItem> {
  items: TDataItem[]
  shouldHideDate?: boolean
  className?: string
  children?: ReactNode
  renderItem: (item: TDataItem, index: number) => ReactNode
}

export const ReviewTimelineLayout = <TDataItem extends ReviewTimelineItem>({
  shouldHideDate,
  className,
  children,
  items,
  renderItem,
}: ReviewTimelineLayoutProps<TDataItem>) => (
  <S.ReviewTimelineContainer className={className}>
    <S.TimeLine shouldHideDate={shouldHideDate} />
    <S.ReviewRightSide shouldHideDate={shouldHideDate}>{children}</S.ReviewRightSide>

    {items.map((item, index) => {
      // Required to keep UTC for consistency with overview stats that are calculated in UTC
      const formattedDate = formatDate(
        parseISODate(item.createdAt).toUTCString(),
        'MMM dd, yyyy hh:mm a',
      )

      return (
        <S.ReviewContainer key={item.id}>
          {!shouldHideDate ? <S.CreatedAtDate>{formattedDate}</S.CreatedAtDate> : null}
          <Tooltip content={formattedDate} disabled={!shouldHideDate} placement="bottom">
            <S.TimelineDot />
          </Tooltip>
          {renderItem(item, index)}
        </S.ReviewContainer>
      )
    })}
  </S.ReviewTimelineContainer>
)
